import React, { FunctionComponent } from 'react';
import { Box, FormHelperText, Grid, Hidden, makeStyles, Theme } from '@material-ui/core';
import gray from '@material-ui/core/colors/grey';
import classNames from 'classnames';
import moment from 'moment';
import { FormFieldProps } from '../FormFieldDisplay';
import DatePicker from '../../../DatePicker';

const useStyles = makeStyles((theme: Theme) => ({
    inputCustomStyle: {
        fontSize: 16,
    },
    detailNodeLabelSm: {
        fontSize: 14,
        fontWeight: 500,
        color: theme.palette.text.secondary,
        textAlign: 'left',
        justifyContent: 'right',
        marginRight: 30,
        lineHeight: '21px',
    },
    detailNodeLabel: {
        fontSize: 14,
        fontWeight: 500,
        color: gray[800],
        textAlign: 'right',
        justifyContent: 'right',
        marginRight: 30,
        lineHeight: '21px',
    },
    detailNodeValue: {
        fontSize: 14,
        fontWeight: 450,
        color: gray[600],
        lineHeight: '21px',
        wordWrap: 'break-word',
    },
    borderedInputs: {
        border: '1px solid rgb(0,0,0,0.23) !important',
        padding: 7,
        borderRadius: 3,
        marginBottom: '5px',
    },
    disabled: {
        color: '#484848 !important',
    },
    datePicker: {
        margin: 0,
    },
    datePickerContainer: {
        backgroundColor: 'white',
        borderRadius: 5,
        justifyContent: 'flex-start',
    },
    underline: {
        '&:before': {
            borderBottomColor: 'white',
        },
        '&:after': {
            borderBottomColor: 'white',
        },
        '&:hover:before': {
            borderBottomColor: ['white', '!important'],
        },
    },
}));

const DatePickerFormField: FunctionComponent<FormFieldProps> = (props) => {
    const { formField, error, readOnly, handleInputChange, value, isCustomStyle } = props;
    const classes = useStyles();

    const inputClasses = classNames({
        [classes.inputCustomStyle]: true,
        [classes.disabled]: !readOnly,
        [classes.borderedInputs]: !readOnly,
        [classes.underline]: !readOnly,
    });

    return (
        <Grid container alignItems="center">
            <Grid item xs={isCustomStyle ? 3 : 6}>
                <Hidden smUp={true}>
                    <Box component="div" className={classes.detailNodeLabelSm}>
                        {formField.label}
                    </Box>
                </Hidden>
                <Hidden xsDown={true}>
                    <Box component="div" className={classes.detailNodeLabel}>
                        {formField.label}
                    </Box>
                </Hidden>
            </Grid>
            <Grid item xs={isCustomStyle ? 9 : 6}>
                <Box component="div" className={classes.detailNodeValue}>
                    {!readOnly && (
                        <>
                            <DatePicker
                                containerClasses={classes.datePickerContainer}
                                datePickerClasses={classes.datePicker}
                                inputProps={{
                                    classes: {
                                        root: inputClasses,
                                    },
                                }}
                                value={value}
                                error={error?.error}
                                handleDate={(date: string) => {
                                    const momentDate = moment(date);
                                    if (momentDate.isValid()) {
                                        handleInputChange(formField.field, momentDate.format('YYYY-MM-DD'));
                                    }
                                    if (date === '') {
                                        handleInputChange(formField.field, '');
                                    }
                                }}
                                label=""
                                fullWidth={true}
                            />
                            {error?.messages?.map((msg, index) => (
                                <FormHelperText key={index} error={true}>
                                    {msg}
                                </FormHelperText>
                            ))}
                        </>
                    )}
                    {readOnly && (
                        <Box component="div" className={classes.detailNodeValue}>
                            {value ? moment(value).format('L') : ''}
                        </Box>
                    )}
                </Box>
            </Grid>
        </Grid>
    );
};

export default DatePickerFormField;
